export default "/_next/static/images/product-contacts-3270317eea69772d5414c58e5885723c.svg";